import { ZViewerView, type IViewerView } from "@multiconsult-group/multiplacer-core";

/** Compare all display settings, ignoring property and filter-selection ordering. */
export const viewerViewFingerprint = (view: IViewerView): string => {
  // Parsing gives nested validation fields a stable property order as well.
  const parsed = ZViewerView.parse(view);
  return JSON.stringify({
    schemaVersion: parsed.schemaVersion,
    modules: parsed.modules,
    roomPanelTab: parsed.roomPanelTab,
    componentColorMode: parsed.componentColorMode,
    articleColoringId: parsed.articleColoringId ?? null,
    roomColoringId: parsed.roomColoringId,
    visibility: parsed.visibility.mode === "INSTANCE_CLASS"
      ? { mode: "INSTANCE_CLASS", ifcClasses: [...parsed.visibility.ifcClasses].sort((a, b) => a.ifcClass.localeCompare(b.ifcClass)) }
      : { mode: "DISCIPLINE", disciplines: [...parsed.visibility.disciplines].sort() },
  });
};
